
import React, { useState } from 'react'
import styled from 'styled-components'
import { LargeButton } from '../components/core'
import SideNav from '../components/sideNav'
import SideNavContent from '../components/sideNavContent'
import HeaderDasNew from '../components/core/headerDasNew'

const ThankYouMsg = () => {
    const company_name = localStorage.getItem('company_name')
    const showSidebar = () => {
        return !!localStorage.getItem('id')
    }
    return (
        <>
            <SideNav>
                {
                    showSidebar() && 
                    <SideNavContent />
                }
            </SideNav>
            <HeaderDasNew company_name={company_name} />
            {/* <HomeWrapper> */}
                <Body>
                    <Root>
                        <TextUpper>Thank You!</TextUpper>
                        <Text>The endorsement file has been shared with the insurer. </Text>
                    </Root>
                </Body>
            {/* </HomeWrapper> */}
        </>
    )
}

const Body = styled.div`
    padding: 50px 80px;
    margin-left: 200px;
    display: flex;
    flex: 1;
    justify-content: center;
    background-color: #ffffff;
`

const Root = styled.div`
  display: flex;
  padding: 8rem 10rem;
  width: 86%;
  /* height: 200px; */
  margin-top: 10rem;
  flex-direction: column;
  background-color : #FDF6E9;
  border-radius : 12px;
  justify-content: center;
  align-items: center;
`
const TextUpper = styled.p`
  text-align: center;
  font-family: 'Inter';
  font-size: 30px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
`

const Text = styled.p`
  margin: 12px 0 24px 0;
  text-align: center;
  font-family: 'Inter';
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
`

export default ThankYouMsg